import snakeCase from 'lodash.snakecase'
import transformObjectKeys from './transformObjectKeys'

export default function snakeCaseObjectKeys(object) {
  return transformObjectKeys(object, snakeCase)
}
